import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActiveMesswertTableFilter, MesswertTableColumn, MesswertTableFilter} from '../../../../model/component/messwert-table-filter';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';

@Component({
  selector: 'app-messwert-filter',
  templateUrl: './messwert-filter.component.html',
  styleUrls: ['./messwert-filter.component.css']
})
export class MesswertFilterComponent {

  public source: MesswertTableFilter = MesswertTableFilter.SOURCE_FILTER;

  public streetType: MesswertTableFilter = MesswertTableFilter.STREET_TYPE_FILTER;

  public region: MesswertTableFilter[] = MesswertTableFilter.REGIONS_FILTER;

  allComplete = false;
  selectedSourceNames = ['DWD'];
  selectedRegionName = 'Deutschland';

  additionalColumns: MesswertTableColumn[] = MesswertTableColumn.OPTIONAL_COLUMNS;

  @Input()
  isRefreshing = false;

  @Output()
  onFilterChange: EventEmitter<ActiveMesswertTableFilter> = new EventEmitter<ActiveMesswertTableFilter>();
  @Output()
  onColumnsChange: EventEmitter<MesswertTableColumn> = new EventEmitter<MesswertTableColumn>();
  showValuesOlderOneHour: boolean = true;

  updateAllComplete() {
    this.allComplete = this.source.subSources != null && this.source.subSources.every(s => s.completed);
    this.applyFilter();
  }

  someComplete() {
    if (this.source.subSources == null) {
      return false;
    }
    return this.source.subSources.filter(s => s.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.selectedSourceNames = [];
    this.allComplete = completed;
    if (this.source.subSources == null) {
      return;
    }
    this.selectedSourceNames.push('DWD');
    this.selectedSourceNames.push('MG');
    this.source.subSources.forEach(s => s.completed = completed);
  }

  applyFilter() {
    if (this.selectedSourceNames !== null && this.selectedSourceNames !== undefined) {
      // console.log('Filter Applied');
      this.onFilterChange.emit({
        quellen: this.selectedSourceNames.join('').toUpperCase(),
        region: this.selectedRegionName.toUpperCase(),
        hasStreetFilterActive: this.streetType.completed,
        showValuesOlderThanOneHour: this.showValuesOlderOneHour
      });
    }
  }

  updateSelectedSourceFilter() {
    this.selectedSourceNames = [];
    for (const s of this.source.subSources) {
      if (s.completed) {
        this.selectedSourceNames.push(s.name);
      }
    }
  }

  updateSelectedRegionFilter(name: string) {
    this.selectedRegionName = name;
    for (const r of this.region) {
      r.completed = r.name === name;
    }
  }

  addColumn(col: MesswertTableColumn) {
    col.selected ? col.selected = false : col.selected = true;
    this.onColumnsChange.emit(col);
  }

  onToggleValuesOlderOneHourChange($event: MatSlideToggleChange) {
    this.applyFilter();
  }
}
